import { BaseModel } from './base-model';
import { GlobalFilterVesselMetaData, GlobalSearchsVesselsMetaData, VesselInfo } from './types/vessels-model.types';

export abstract class VesselsModelBase extends EventTarget {
    abstract get maerskVessels(): Map<number,VesselInfo>;
    abstract get nonMaerskVessels(): Map<number,VesselInfo>;
    abstract get globalFilterMetadataMaerskVessels(): GlobalFilterVesselMetaData[];
    abstract get globalFilterMetadataNonMaerskVessels(): GlobalFilterVesselMetaData[];
    abstract get globalSearchVesselsMetaData(): GlobalSearchsVesselsMetaData[];
    abstract get globalSearchMaerskVesselsMetaData(): GlobalSearchsVesselsMetaData[];
    abstract get globalSearchNonMaerskVesselsMetaData(): GlobalSearchsVesselsMetaData[];

    abstract getVessel(imoNo: number): VesselInfo | undefined;
    abstract getVesselName(imoNo: number): string | undefined;
    abstract refreshVessels(): Promise<void>;
    abstract plotVessel(imoNo: number): void;
    abstract getFilterCategoryCount(id:string):number | undefined;
    abstract getAllVesselsClasses(): string[];
}

let VesselsModel: VesselsModelBase | null = null;

function setVesselsModel(model: VesselsModelBase) {
    VesselsModel = model;
}

export { VesselsModel, setVesselsModel };
